<template>
	<input-sd2000 v-model="treatedItemValue" :settings="settings" />
</template>
<script>
	import inputSd2000 from '../../solicitacoes/mdExams/inputSd2000';

	export default {
		props: {
			value: {
				defult: null,
			},
			settings: {
				defult: null,
			},
		},
		components: {
			inputSd2000,
		},
		computed: {
			treatedItemValue: {
				set(val) {
					console.log(val);
				},
				get() {
					if (this.settings.f == 'N') {
						const baseNumber = parseFloat(
							this.value.replace(/\./gi, '').replace(',', '.')
						);
						return baseNumber.toFixed(this.settings.dec);
					} else {
						return this.value;
					}
				},
			},
		},
	};
</script>



// WEBPACK FOOTER //
// src/components/sd2000/import/components/TreatedInputSd2000.vue